import { connect } from "react-redux";
import AttendanceDetails from "./attendanceDetails";
import { bindActionCreators } from "redux";
import { getProfile } from 'services/redux/auth/login/action';

import {
  employeeAttendanceData,
  employeeCheckOutData,
  getAttendanceLocationType,
  getAttendanceOfficeList,
  getAttendanceSiteList,
} from "services/redux/sales/attendance/action";

const mapStateToProps = (state) => ({
  attendanceData: state.attendanceReducer.attendanceData,
  attendanceOfficeList: state.attendanceReducer.attendanceOfficeList,
  attendanceSiteList: state.attendanceReducer.attendanceSiteList,
  userProfile : state.loginReducer.userProfile.attVal,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getAttendanceLocationType,
      employeeCheckOutData,
      getProfile,
      getAttendanceOfficeList,
      getAttendanceSiteList,
      employeeAttendanceData,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(AttendanceDetails);
